// import { useEffect } from 'react';
import { CurrencyFormatter } from '@utils/formatters/CurrencyFormatter';
import { NEXT_PUBLIC_NO_PRICE_FALLBACK } from '@config/environment';
import { useSegment } from '@hooks/useSegment';
import { useQuery } from '@apollo/client';
import {
  GetCheckoutPaymentMethodQueryResponse,
  GetCheckoutPaymentMethodQueryParams,
  getCheckoutPaymentMethod,
} from '@queries/checkout/queries/paymentMethod';
import { useOrderState } from '@hooks/useOrderState';
import {
  usePaymentMethodActions,
  usePaymentSelectors,
} from '../zustand/paymentMethodStore';
import { useMekiState } from '@hooks/useMekiState';
import { SwitchCard } from './SwitchCard';
import { useEffect, useRef } from 'react';

interface MekiCreditsProps {
  loading: boolean;
}

export function MekiCredits({ loading }: MekiCreditsProps) {
  const { track } = useSegment();
  const { orderUuid } = useOrderState();

  const { mekiCreditsChecked: checked } = usePaymentSelectors();
  const { setMekiCreditsChecked } = usePaymentMethodActions();
  const { setInsuranceId } = useMekiState();

  const { data: orderAndUserInfoData, loading: loadingCredits } = useQuery<
    GetCheckoutPaymentMethodQueryResponse,
    GetCheckoutPaymentMethodQueryParams
  >(getCheckoutPaymentMethod(), {
    fetchPolicy: 'cache-first',
    variables: { params: { orderUuid } },
  });
  const { currentUserInfo } = orderAndUserInfoData ?? {};
  const credits = currentUserInfo?.credits ?? 0;

  const handleMekiCreditsChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setMekiCreditsChecked(event.target.checked);
    setInsuranceId(null);
    track('change credits use', {
      activated: event.target.checked,
    });
  };
  const loadedCredits = useRef(false);
  useEffect(
    function checkCreditsOnLoad() {
      if (loadingCredits) return;
      if (loadedCredits.current) return;
      loadedCredits.current = true;
      setMekiCreditsChecked(credits > 0);
    },
    [credits, loadingCredits],
  );

  const currencyFormatter = new CurrencyFormatter({
    fallback: NEXT_PUBLIC_NO_PRICE_FALLBACK,
  });

  const label = `Créditos Meki: ${
    credits === 0 ? '$0' : currencyFormatter.format(credits)
  }`;

  return (
    <SwitchCard
      label={label}
      onChange={handleMekiCreditsChange}
      checked={checked}
      loading={loading}
    />
  );
}
